import { SingleSelect } from "@learningblocks/simulations/shared-components/lib/Questions/SingleSelect";
import React, { useState } from "react";
import { Utilities } from "@learningblocks/exp-constants";
import cname from "../../style.module.scss";
import { useDispatch } from "react-redux";
import { troubleshootDone, useSpectrophotometer } from "../../store";
import { Controller } from "../../SpectrophotometerConfigModal/Controller";

const { QUESTION_CONTENTS } = Utilities;

const staticContent = {
  [QUESTION_CONTENTS.TEXT]: {
    text: `<h2>Troubleshoot</h2><h3>Alert!</h3><p>The absorbance value for your sample is above 1.0. The sample is too concentrated to be measured accurately.</p>`,
  },
  [QUESTION_CONTENTS.QUESTION]: {
    text: "<h3>What do you need to do?</h3>",
  },
};
export const Content = () => {
  const [options, setOptions] = useState([
    {
      id: 1,
      text: "Set the absorbance of the sample to zero by pressing the zero button.",
      disabled: false,
      selected: false,
      value: "Zero",
      feedback:
        "Before measuring the sample, you calibrated the spectrophotometer with the blank cuvette. Samples cannot be used for zeroing, since you wouldn’t be able to read its real absorbance anymore. ",
    },
    {
      id: 2,
      text: "Change the wavelength.",
      disabled: false,
      selected: false,
      value: "Wavelength",
      feedback:
        "Changing the wavelength would not address the problem that the sample is too concentrated.",
    },
    {
      id: 3,
      text: "Dilute the sample.",
      disabled: false,
      selected: false,
      value: "Dilute",
      feedback:
        "Diluting the sample results in an absorbance value that lies within the preferred linear range of the instrument. The ideal range is between 0.1 and 1.0.",
    },
  ]);
  const correct = 3;
  const [completed, setCompleted] = useState(false);
  const [attempts, setAttempts] = useState(2);
  const [showFeedback, setShowFeedback] = useState(false);
  const dispatch = useDispatch();
  const { absorbanceValue, relativeAbsorbance, wavelength } =
    useSpectrophotometer();

  const onSelect = ({ optionID }: { optionID: number }) => {
    setOptions(options.map((o) => ({ ...o, selected: o.id === optionID })));
  };
  const onAnswer = () => {
    const selected = options.find((o) => o.selected);
    if ((selected && selected.id === correct) || attempts - 1 === 0) {
      setOptions(options.map((o) => ({ ...o, disabled: true })));
      setCompleted(true);
      dispatch(troubleshootDone());
      setAttempts(0);
    } else {
      setAttempts(attempts - 1);
      setOptions(options.map((o) => ({ ...o, disabled: o.selected })));
    }
  };
  const content = {
    ...staticContent,
    [QUESTION_CONTENTS.OPTIONS]: options,
  };
  return (
    <div className={cname.content}>
      <div className={cname.controllerView}>
        <Controller
          poweredUp
          disabled
          wavelength={wavelength}
          absorbanceValue={absorbanceValue}
          relativeAbsorbance={relativeAbsorbance}
          onClickPowerButton={() => {}}
          onClickZeroButton={() => {}}
          setWavelength={() => {}}
        />
      </div>
      <SingleSelect
        complete={completed}
        content={Object.keys(content)}
        answerId={[correct]}
        totalAttempts={attempts}
        submitAnswer={onAnswer}
        selectOption={onSelect}
        onShowFeedback={() => setShowFeedback(true)}
        showFeedback={showFeedback}
        resetAnswer={() => {}}
        {...content}
        preview={true}
      />
    </div>
  );
};
